<template>
  <div class="Learn">

    <transition name="Learn-container-">

      <div class="Learn-container" :key="activeItem.id">

        <div class="Learn-header">

          <p class="Learn-supertitle t-caps"
            v-if="activeItem.content.supertitle"
            v-html="activeItem.content.supertitle">
          </p>

          <p class="Learn-title t-headingMd"
            v-if="activeItem.content.title"
            v-html="activeItem.content.title">
          </p>

        </div>

        <div class="Learn-content">

          <component :is="activeItem.template" :content="activeItem.content" />

        </div>

        <div class="Learn-footer">

          <div class="Learn-buttons"
            v-if="activeItem.buttons">

            <div class="Learn-button"
              v-for="button in activeItem.buttons"
              @click="nextItem">

              <button-component>
                {{ button.label }}
              </button-component>

            </div>

          </div>

          <div class="Learn-dots">

            <div class="Learn-dot"
              v-for="(item, index) in dots"
              :class="learnDotClass(item, index)">
            </div>

          </div>

        </div>

      </div>

    </transition>

  </div>
</template>

<script>
import AnswerText from 'components/Learn/AnswerText'
import BarChart from 'components/Learn/BarChart'
import ButtonComponent from 'components/Button'
import MultipleChoice from 'components/Learn/MultipleChoice'
import PopUp from 'components/Learn/PopUp'
import Slider from 'components/Learn/LearnSlider'
import TrueFalse from 'components/Learn/TrueFalse'

export default {
  name: 'Learn',

  components: {
    AnswerText,
    BarChart,
    ButtonComponent,
    MultipleChoice,
    PopUp,
    Slider,
    TrueFalse
  },

  props: {
    items: {
      type: Array,
      required: true
    }
  },

  data () {
    return {
      activeDotIndex: 0
    }
  },

  computed: {
    activeIndex () { return (this.$route.query.page - 1) || 0 },
    activeItem () { return this.items[this.activeIndex] },
    nextLearnPage () { return this.$store.state.nextLearnPage },

    /**
     * Dots are only for items that are questions
     * @return {Array}
     */
    dots () {
      const dots = []

      this.items.forEach((item, index) => {
        if (!item.question) return
        dots.push(index)
      })

      return dots
    }
  },

  created () {
    this.dots.forEach((questionIndex, dotIndex) => {
      if (this.$route.query.page - 1 === questionIndex) {
        this.activeDotIndex = dotIndex
      } else if (this.$route.query.page - 2 === questionIndex) {
        this.activeDotIndex = dotIndex
      }
    })
  },

  mounted () {
    // Wait a little for the analytics start event to dispatch
    setTimeout(() => {
      this.$analytics.event(`Learn/Survey${this.activeItem.id}`)
    }, 100)
  },

  watch: {
    activeIndex () {
      if (!this.activeItem.id) return
      this.$analytics.event(`Learn/Survey${this.activeItem.id}`)
    },

    '$route.query' () {
      // If there is no `page` query item, reset dot index
      if (!this.$route.query.page) {
        this.activeDotIndex = 0
      }

      this.dots.forEach((questionIndex, dotIndex) => {
        if (this.$route.query.page - 1 === questionIndex) {
          this.activeDotIndex = dotIndex
        }
      })
    },

    nextLearnPage () {
      if (!this.nextLearnPage) return
      this.nextItem()
    }
  },

  methods: {
    /**
     * Go to the next item
     */
    nextItem () {
      const nextIndex = this.activeIndex < this.items.length - 1
        ? this.activeIndex + 1
        : 0

      this.$router.push({
        query: { page: nextIndex + 1 }
      })
    },

    _nextItem () {
      let nextIndex

      if (this.activeIndex < this.items.length - 1) {
        nextIndex = this.activeIndex + 1

        // Increment active dot index
        if (this.items[nextIndex].question) this.activeDotIndex++
      } else {
        nextIndex = 0
        this.activeDotIndex = 0
      }

      this.$router.push({
        query: {
          page: nextIndex + 1
        }
      })
    },

    /**
     * Class for learn dots
     * @param  {Object} item
     * @param  {Integer} index
     * @return {Object}
     */
    learnDotClass (item, index) {
      return {
        'Learn-dot--isSelected': index === this.activeDotIndex
      }
    }
  }
}
</script>

<style>
.Learn {
  z-index: 0;
  flex-grow: 1;
}

.Learn-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  width: 930px;
  height: 930px;
}

.Learn-container--enter-active,
.Learn-container--leave-active {
  transition: opacity 1s ease;
}

.Learn-container--enter,
.Learn-container--leave-to {
  opacity: 0;
}

.Learn-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  width: 652px;
  height: 22%;
}

.Learn-supertitle + .Learn-title {
  margin-top: 1rem;
}

.Learn-title {
  color: var(--color-5);
}

.Learn-content {
  flex-grow: 1;
  display: flex;
}

.Learn-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 5%;
  max-width: 63%;
  height: 13%;
}

.Learn-buttons {

}

.Learn-button {

}

.Learn-buttons + .Learn-dots {
  margin-top: 40px;
}

.Learn-dots {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Learn-dot {
  margin: 0 1.5px;
  width: 16px;
  height: 16px;
  border: 2px solid var(--color-3);
  border-radius: 50%;
  background-color: rgba(255,255,255,0.5);
}

.Learn-dot--isSelected {
  background-color: var(--color-3);
}
</style>



// WEBPACK FOOTER //
// Learn.vue?419572f6